// extracted by mini-css-extract-plugin
export var coreSkills = "core-skills-module--coreSkills--0e9a0";
export var skills = "core-skills-module--skills--ee8d8";